import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {ICrudRes} from "../../../interface/http.config";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-link',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './link.component.html',
  styleUrl: './link.component.scss'
})
export class LinkComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/link-edit/';
  override addLink = '/dashboard/link-create';

  clientList: Record<string, string> = {};
  clientListMap: {value: string, label: string}[] = [];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('link');
    // this.crudService.orderBy = 'createdAt';

  }

  protected tableConfig: ITableConfig = {
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Order',
        field: 'order',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Column',
        field: 'column',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'Href',
        field: 'href',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'ES',
        field: 'title_es',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'EN',
        field: 'title_en',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
    ],
    actions: [
      'edit',
    ]
  };

  ngOnInit() {
    this.update();

    this.crudService.getList('client', 'id', 'email').then(data => {
      this.clientList = data;
      this.clientListMap = listFromMap(data);

      this.cdr.detectChanges();
    });
  }
}
